import { render, staticRenderFns } from "./CollectFormItem.vue?vue&type=template&id=36f00f8d&scoped=true&"
import script from "./CollectFormItem.vue?vue&type=script&lang=js&"
export * from "./CollectFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectFormItem.vue?vue&type=style&index=0&id=36f00f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f00f8d",
  null
  
)

export default component.exports